import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface FieldProps {
  label: string;
  children: ReactNode;
  /** Подсказка под полем — показывается, только если нет ошибки. */
  hint?: ReactNode;
  error?: ReactNode;
  className?: string;
}

function Body({ label, children, hint, error }: FieldProps): JSX.Element {
  return (
    <>
      <span className="label-caps mb-1.5 block">{label}</span>
      {children}
      {error ? (
        <span className="mt-1.5 block text-[13px] text-destructive">{error}</span>
      ) : hint ? (
        <span className="mt-1.5 block text-[13px] text-muted-foreground">{hint}</span>
      ) : null}
    </>
  );
}

/** Поле формы вокруг одного инпута: подпись связана с ним через <label>. */
export function Field({ className, ...props }: FieldProps): JSX.Element {
  return (
    <label className={cn('mb-3.5 block', className)}>
      <Body {...props} />
    </label>
  );
}

/** То же, но для группы кнопок-таблеток: <label> вокруг нескольких кнопок врёт о смысле. */
export function FieldGroup({ className, ...props }: FieldProps): JSX.Element {
  return (
    <div className={cn('mb-3.5', className)}>
      <Body {...props} />
    </div>
  );
}
